import {
  GET_COUPON_DETAIL_LIST_RESPONSE,
  ADD_COUPON_DETAIL_RESPONSE,
  UPDATE_COUPON_DETAIL_BY_COUPON_DETAIL_ID_RESPONSE,
  UPDATE_COUPON_DETAIL_STATUS_BY_COUPON_DETAIL_ID_RESPONSE,
  DELETE_COUPON_DETAIL_BY_COUPON_DETAIL_ID_RESPONSE,
} from "./actionTypes";

import produce from "immer";

export const initialState = {
  couponDetailApiResponse: null,
  couponDetailData: [],
  couponDetailList: [],
  couponDetailRecord: null,
};

const couponDetail = (state = initialState, action) =>
  produce(state, (draft) => {
    let response;
    switch (action.type) {
      case GET_COUPON_DETAIL_LIST_RESPONSE:
        response = action.payload.apiResponse;
        if (response.isSuccessResponse) {
          draft.couponDetailData = response.responseData;
        } else {
          draft.couponDetailData = [];
        }
        break;

      case ADD_COUPON_DETAIL_RESPONSE:
        draft.couponDetailApiResponse = action.payload.apiResponse;
        break;

      case UPDATE_COUPON_DETAIL_BY_COUPON_DETAIL_ID_RESPONSE:
        draft.couponDetailApiResponse = action.payload.apiResponse;
        break;

      case UPDATE_COUPON_DETAIL_STATUS_BY_COUPON_DETAIL_ID_RESPONSE:
        draft.couponDetailApiResponse = action.payload.apiResponse;
        break;

      case DELETE_COUPON_DETAIL_BY_COUPON_DETAIL_ID_RESPONSE:
        draft.couponDetailApiResponse = action.payload.apiResponse;
        break;

      default:
        state = { ...state };
        break;
    }
  });

export default couponDetail;
